/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import firebase from 'firebase/app'
import 'firebase/auth'

// Stripe initialization
import { loadStripe } from '@stripe/stripe-js'
export const stripePromise = loadStripe('pk_live_51Hf73KIFtsmSR9hIq8Ka8d4KvMTm9UVMWHOdNCBU02BmC6rcWPwgHs371YWh6iQ456OCZvJzsrHh5oL36SjPvYng00wvfOFtwU')

// router setup
import router from './routes/starterRouter';
// plugin setup
Vue.use(DashboardPlugin);

let app = null;

// Wait for firebase auth to init before creating the app
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      render: h => h(App),
      router
    }).$mount('#app')
  }
})
